import {EnvironmentDefinition} from './environmentDefinition';

export const environment: EnvironmentDefinition = {
  'production': true,
  'apiURL': ''
};
